import React from 'react';
import { useNavigate } from 'react-router-dom';

/**
 * DashboardInsights — actionable recommendations from the API.
 *
 * Always renders — shows guidance even when no data is available yet.
 *
 * Props:
 *   insights: Array<{ message, action, action_url }>
 *   loading: bool
 */

const InsightItem = ({ insight, onAction }) => (
  <div className="insight-item">
    <span className="insight-item__dot" />
    <div className="insight-item__body">
      <p className="insight-item__message">{insight.message}</p>
      {insight.action && insight.action_url && (
        <button
          className="btn btn-primary btn--sm insight-item__cta"
          onClick={() => onAction(insight.action_url)}
        >
          {insight.action} →
        </button>
      )}
    </div>
  </div>
);

const InsightsSkeleton = () => (
  <div style={{ display: 'flex', flexDirection: 'column', gap: 12 }}>
    {[1, 2].map(i => (
      <div key={i} className="skeleton" style={{ height: 60, borderRadius: 10 }} />
    ))}
  </div>
);

const DashboardInsights = ({ insights = [], loading }) => {
  const navigate = useNavigate();

  return (
    <div className="dashboard-section">
      <div className="dashboard-section__header">
        <h3 className="dashboard-section__title">What to Do Next</h3>
      </div>

      {loading ? (
        <InsightsSkeleton />
      ) : insights.length === 0 ? (
        <div className="empty-state empty-state--inline">
          <span style={{ fontSize: 20 }}>📋</span>
          <span>Add your first product and record a sale to get recommendations.</span>
        </div>
      ) : (
        <div className="insights-list">
          {insights.map((insight, idx) => (
            <InsightItem
              key={idx}
              insight={insight}
              onAction={(path) => path && navigate(path)}
            />
          ))}
        </div>
      )}
    </div>
  );
};

export default DashboardInsights;
